module.exports = __webpack_public_path__ + "img/Sbit-logo.98730382.png";